module.exports = __webpack_public_path__ + "img/itx-file-type-wav.194c4f69.svg";